import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useEffect, useState } from "react";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import { GetUserProfile, SetUserProfile } from "../../services/ProfileService";
import { fetchUserProfile } from "../../features/profile/profileSlice";
import { useDispatch } from "react-redux";
import { FOREGROUNDCOLOR } from "../../helpers/colors";
import { Password } from "primereact/password";
import ChangePassword from "../account/ChangePassword";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ChangePasswordApi } from "../../services/AccountService";
import toast from "react-hot-toast";
import { Dialog } from "primereact/dialog";
import { GetMyInvitations } from "../../services/InvitationService";
//import { ChangeProfile, GetProfile } from "services/ProfileService";

const Profile = () => {
  const [showModal, SetShowModal] = useState(false);
  const [getProfile, SetProfile] = useState({ firstName: "", lastName: "" });
  const [isEdit, SetIsEdit] = useState(false);
  const [isRegister, SetIsRegister] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const setActiveIndex = useOutletContext();
  const location = useLocation();
  const currentURL = location.pathname;
  const [invitations, setInvitations] = useState(null);
  const params = useParams();
  async function GetMyInvitationsAsync() {
    await GetMyInvitations().then((p) => setInvitations(p.data.data));
  }

  useEffect(() => {
    GetProfiles();
    console.log("currentURL", currentURL);

    if (currentURL.startsWith("/confirm/Profile")) {
      SetIsRegister(true);
      (setActiveIndex as any)(2);
      GetMyInvitationsAsync();
    } else {
      SetIsRegister(false);
    }
  }, []);

  useEffect(() => {
    GetProfiles();
  }, [isEdit]);

  const Refresh = () => {
    navigate("/");
  };

  const GetProfiles = async () => {
    await GetUserProfile().then((p) =>
      p.data.data !== null ? SetProfile(p.data.data) : console.log("no profile")
    );
  };

  const SetDataInfo = (event: any) => {
    SetProfile({
      ...getProfile,
      [event.target.name]: event.target.value,
    });
  };

  const submit = async () => {
    await SetUserProfile(getProfile.firstName, getProfile.lastName)
      .then((p) => SetIsEdit(false))
      .then(() => {
        dispatch(fetchUserProfile()).then(() => {
          // navigate("/");
        });
      });
  };

  return (
    <>
      <div className="mt-1 card p-5">
        <div>
          <InputText
            name="firstName"
            type="text"
            style={{ width: "100%", marginLeft: "5px" }}
            className="block mb-2"
            placeholder={
              getProfile?.firstName === "" ? "نام" : getProfile.firstName
            }
            onChange={SetDataInfo}
          />
        </div>

        <div>
          <InputText
            name="lastName"
            type="text"
            style={{ width: "100%", marginLeft: "5px" }}
            className="block mb-2"
            onChange={SetDataInfo}
            placeholder={
              getProfile?.lastName === "" ? "نام خانوادگی" : getProfile.lastName
            }
          />
        </div>

        <div className=" mt-2  " style={{ width: "100%" }}>
          <div
            style={{
              display: isRegister ? "block" : "none",
            }}
          >
            <Button
              label="ثبت"
              style={{
                width: "100%",
                display: isRegister ? "block" : "none",
              }}
              onClick={() => {
                submit();
                if ((invitations as any).length > 0) {
                  (setActiveIndex as any)(3);
                  navigate(
                    `/Confirm/AcceptedInvitation/${params.invitationCode}`
                  );
                }
              }}
              className="mt-3 p-button-success"
            />
          </div>
          <div className="px-2" style={{ display: "inline-flex" }}>
            <Button
              label="ثبت"
              style={{
                width: "100%",
                display: isRegister ? "none" : "block",
              }}
              onClick={() => SetShowModal(true)}
              className="mt-3 p-button-success"
            />
          </div>
          <div className="px-2" style={{ display: "inline-flex" }}>
            <Button
              label="انصراف"
              style={{
                width: "100%",
                display: isRegister ? "none" : "block",
              }}
              onClick={Refresh}
              className="mt-3  p-button-warning"
            />
          </div>
        </div>
      </div>

      <Dialog
        id="test"
        style={{ width: "30vw", display: "inline-flex" }}
        visible={showModal}
        onHide={() => SetShowModal(false)}
      >
        <h5 className="iran">آیا مایل به ذخیره تغییرات هستید ؟</h5>
        <div style={{ backgroundColor: "transparent", textAlign: "left" }}>
          <Button
            label="بله"
            style={{ width: "20%", height: "2.5rem" }}
            onClick={() => {
              SetShowModal(false);
              submit();
            }}
            className="mt-3 p-button-success iran"
          />{" "}
          <Button
            label="خیر"
            style={{ width: "20%", height: "2.5rem" }}
            onClick={() => SetShowModal(false)}
            className="mt-3 p-button-danger iran"
          />
        </div>
      </Dialog>
    </>
  );
};
export default Profile;
